/* src/app/contract-management/presenters/contract-management-presenters.component.scss */
:host ::ng-deep .contract-accordion .accordion-panel-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
:host ::ng-deep .contract-accordion .table-panel {
  flex: 1 1 auto;
  min-height: 0;
}
:host ::ng-deep .contract-accordion .p-datatable {
  height: 100%;
}
/*# sourceMappingURL=contract-management-presenters.component.css.map */
